var text_field_default = {
  "root": "nN0Cb",
  "text": "_-6V-y",
  "input": "xqSzP",
  "small": "_94bTL",
  "medium": "Y--1T",
  "large": "pmD88",
  "webview": "grWSO",
  "endAdornment": "Ij8bd",
  "shown": "eqyvc",
  "value": "Y8LIB",
  "spinner": "_73fYC",
  "spin": "xCAxG"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
